// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__mtIGA","row":"Node_row__kX1hc","label":"Node_label__29yOB","footer":"Node_footer__1NQuq"};